<div class="countdown-container">
  <div class="time-container">
    <div class="time">
      <h1>{{ days }}</h1>
      <h3>Days</h3>
    </div>
    <div class="time">
      <h1>{{ hours }}</h1>
      <h3>Hours</h3>
    </div>
    <div class="time">
      <h1>{{ minutes }}</h1>
      <h3>Mins</h3>
    </div>
    <div class="time">
      <h1>{{ seconds }}</h1>
      <h3>Secs</h3>
    </div>
  </div>
</div>
